import React from "react";
import { Container } from "reactstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { getCampaignAnalytics, downloadCampaignReport } from "api/CampaignApi";
import ContactLoader from "views/ContantLoader";
import "../styles.css";

var moment = require("moment-timezone");
var cname = sessionStorage.getItem("KW_Campaign_Report_name");


const Campaign_Report = (props) => {
  const [analyticsData, setAnalyticsData] = useState({
    totalClick: 0,
    totalOpen: 0,
    totalBounce: 0,
    totalDelivery: 0,
    totalUnsubscribe: 0,
    totalSend: 0,
  });
  const { campaignId } = useSelector((state) => state.campaignSetter);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Clicks",
        data: [],
        fill: true,
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
      },
      {
        label: "Opens",
        data: [],
        fill: false,
        borderColor: "#742774",
      },
    ],
  });
  const [abTestData, setAbTestData] = useState([])
  let newData = {
    labels: [],
    datasets: [
      {
        label: "Clicks",
        data: [],
        fill: true,
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "#1ABC9C",
      },
      {
        label: "Opens",
        data: [],
        fill: false,
        borderColor: "#FFA06E",
      },
    ],
  };
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const campaign_id = sessionStorage.getItem("KW_Campaign_Report_Id");
    getCampaignAnalytics(campaignId || campaign_id).then((data) => {
      setAnalyticsData(data);
      data["perDateAnalytics"] &&
        data["perDateAnalytics"].map((obj, idx) => {
          var EST = new Date(obj.asOfDate); // Clone UTC Timestamp
          let time = moment(EST)
            .utc(EST)
            .tz("America/New_York")
            .format("hh:mm A");
          let opens = obj.open;
          let clicks = obj.click;
          newData["labels"].push(time);
          newData.datasets[1].data.push(opens);
          newData.datasets[0].data.push(clicks);
        });
      setChartData(newData);
      setLoading(false)
      setAbTestData(data["ABTestAnalytics"]);
    });
  }, []);


  async function handleDownload(type) {
    cname = sessionStorage.getItem("KW_Campaign_Report_name");
    const campaign_id = sessionStorage.getItem("KW_Campaign_Report_Id");

    downloadCampaignReport(campaign_id, type)
      .then((data) => {



        var contentType = "text/csv";
        var csvFile = new Blob([data.data], { type: contentType });

        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(csvFile);
        elem.download = cname + "_" + type + "_Report" + ".csv";
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      })
      .catch((e) => { })
  }
  function handleDownload1() {
    handleDownload("Open");
  }
  function handleDownload2() {
    handleDownload("Click");
  }
  function handleDownload3() {
    handleDownload("Bounce");
  }
  function handleDownload4() {
    handleDownload("Unsubscribe");
  }

  function handleDownload5() {
    handleDownload("Send");
  }

  const scaleOptions = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            min: 0,
            precision: 0,
          },
        },
      ],
    },
  };

  return (
    <Container>
      <div className="board_outer">
        <div className="row">
          <div className="col-xl-7 col-lg -6">
            <div className="cs_heading d-flex align-items-center justify-content-between">
              <h2 className="mb-0">Campaign Report</h2>
            </div>
            <button
              className="btn btn-sm"
              style={{ color: "#114169" }}
              onClick={() => props.history.push(`/admin/campaign/all`)}
            >{`< Back`}</button>
            <div
              style={{
                padding: '10px 12px',
                fontWeight: 700,
                fontSize: '16px'
              }}
            >{sessionStorage.getItem("KW_Campaign_Report_name")}</div>
            <div className="container">
              <div
                id="campaign_stats"
              >
                <div id="campaign_text">
                  <OverlayTrigger
                    delay={{ hide: 50, show: 50 }}
                    placement="top"
                    key="top"
                    overlay={(props) => (
                      <Tooltip id="tooltip-top" {...props}>
                        Download
                      </Tooltip>
                    )}
                  >
                    <h2
                      className="dowH2"
                      onClick={handleDownload5}
                    >
                      <u>{analyticsData.totalSend}</u>
                    </h2></OverlayTrigger>
                  <p>Sent</p>
                </div>
                <div id="campaign_text">
                  <OverlayTrigger
                    delay={{ hide: 50, show: 50 }}
                    placement="top"
                    key="top"
                    overlay={(props) => (
                      <Tooltip id="tooltip-top" {...props}>
                        Download
                      </Tooltip>
                    )}
                  >
                    <h2
                      className="dowH2"
                      onClick={handleDownload1}
                    >
                      <u>{analyticsData.totalOpen} {` (${((analyticsData.totalOpen *100) / (analyticsData.totalSend+ 0.000000000001)).toFixed(2)}%)`}</u>
                    </h2>
                  </OverlayTrigger>

                  <p>Opened</p>
                </div>
                <div id="campaign_text">
                  <OverlayTrigger
                    delay={{ hide: 50, show: 50 }}
                    placement="top"
                    key="top"
                    overlay={(props) => (
                      <Tooltip id="tooltip-top" {...props}>
                        Download
                      </Tooltip>
                    )}
                  >
                    <h2
                      className="dowH2"
                      onClick={handleDownload2}
                    >
                      <u>{analyticsData.totalClick}  {` (${((analyticsData.totalClick *100)/ (analyticsData.totalSend+ 0.000000000001)).toFixed(2)}%)`}</u>
                    </h2></OverlayTrigger>
                  <p>Clicked</p>
                </div>
                <div id="campaign_text">
                  <OverlayTrigger
                    delay={{ hide: 50, show: 50 }}
                    placement="top"
                    key="top"
                    overlay={(props) => (
                      <Tooltip id="tooltip-top" {...props}>
                        Download
                      </Tooltip>
                    )}
                  >
                    <h2
                      className="dowH2"
                      onClick={handleDownload3}
                    >
                      <u>{analyticsData.totalBounce} {` (${((analyticsData.totalBounce*100)/ (analyticsData.totalSend+0.000000000001)).toFixed(2)}%)`} </u>
                    </h2></OverlayTrigger>
                  <p>Bounced</p>
                </div>
                <div id="campaign_text">
                  <OverlayTrigger
                    delay={{ hide: 50, show: 50 }}
                    placement="top"
                    key="top"
                    overlay={(props) => (
                      <Tooltip id="tooltip-top" {...props}>
                        Download
                      </Tooltip>
                    )}
                  >
                    <h2
                      className=
                      "dowH2"

                      onClick={handleDownload4}
                    >
                      <u>{analyticsData.totalUnsubscribe} {` (${((analyticsData.totalUnsubscribe *100)/ (analyticsData.totalSend+0.000000000001)).toFixed(2)}%)`}</u>
                    </h2></OverlayTrigger>
                  <p>Unsubscribed</p>
                </div>

              </div>

              {abTestData?.length > 0 && <>
                <h4 className="mb-0">AB Test Analytics</h4>
                <div className="campaign_report">


                  <div className="abTestReportAccordion">
                    <table style={{ width: "100%" }} className="mb-0">
                      <thead>
                        <tr className="mb-1">
                          <th>Campaign</th>
                          <th>Subject</th>
                          <th>Schedule</th>
                          <th>Sent</th>
                          <th>Opened</th>
                          <th>Clicked</th>
                          <th>Winner</th>
                        </tr>
                      </thead>
                      <tbody>
                        {abTestData.map((item, index) => (
                          <tr key={index}>
                            <td>{item.campaign}</td>
                            <td>{item.subject}</td>
                            <td>{item.schedule}</td>
                            <td>{item.sent}</td>
                            <td>{item.open}</td>
                            <td>{item.click}</td>
                            <td>{item.winner}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="campaign_report_header">
                    <span className="campaign_report_time">Wait Time: {analyticsData.ABTestData.waitTime} Hrs</span>
                    <span className="campaign_report_percentage ml-5">Sample Audience: {analyticsData.ABTestData.samplePercentage}% </span>
                  </div>
                </div>
              </>}

              <h4 className="mb-0">24-hours Performance (EST)</h4>
              <div id="campaign_chart">
                {loading ?
                  <ContactLoader />
                  :
                  <Line data={chartData} options={scaleOptions} />
                }
              </div>
              <h4 className="mb-0">Top Links Clicked</h4>
              <div id="campaign_link_text">
                {analyticsData["totalClickPerLink"] &&
                  analyticsData.totalClickPerLink.length > 0 ? (
                  analyticsData["totalClickPerLink"] &&
                  analyticsData["totalClickPerLink"].map((obj, idx) => {
                    return (
                      <div id="text_list" key={idx}>
                        <a target="_blank" href={obj.link} title={obj.link}>
                          <p style={{ overflow: "hidden", maxWidth: "30vw" }}>
                            {obj.link}
                          </p>
                        </a>
                        <p>{obj.count}</p>
                      </div>
                    );
                  })
                ) : (
                  <p role="alert">No Data Available!</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default Campaign_Report;
